import type { CSSProperties } from 'react';

import { Alert, styled } from '@mui/material';

type AlertProps = {
  isLink?: boolean;
  alignSelfIcon?: CSSProperties['alignSelf'];
};
export const CustomAlertStyle = styled(Alert, {
  shouldForwardProp: (prop: string) => !['isLink', 'alignSelfIcon'].includes(prop),
})<AlertProps>(({ theme, isLink, alignSelfIcon }) => ({
  '&.MuiAlert-root': {
    padding: '12px',
    minHeight: '36px',
    height: 'max-content',
    alignItems: 'center',
    gap: '8px',
    cursor: isLink ? 'pointer' : 'initial',
    '& .MuiAlert-message': {
      padding: '0px',
      fontSize: theme.typography.t14r.fontSize,
      fontWeight: theme.typography.t14r.fontWeight,
      fontStyle: theme.typography.t14r.fontStyle,
      lineHeight: theme.typography.t14r.lineHeight,
      marginTop: '1px',
      overflow: 'visible',
    },
    '& .MuiAlert-action': {
      maxHeight: '20px',
      padding: '0px',
      marginRight: '0px',
      alignSelf: 'flex-start',

      svg: {
        width: '20px',
        height: '20px',
        path: {
          fill: theme.palette.case.blue.b600,
        },
      },
    },
    '& .MuiAlert-icon': {
      alignSelf: alignSelfIcon ?? 'center',
      padding: '0px',
      marginRight: '0px',
      svg: {
        width: '20px',
        height: '20px',
      },
    },
  },

  '&.MuiAlert-standard': {
    borderRadius: '8px',
    '&.MuiAlert-standardInfo': {
      border: `1px solid ${theme.palette.case.blue.b200}`,
      backgroundColor: theme.palette.case.blue.b100,
      '& .MuiAlert-message': {
        color: isLink ? theme.palette.case.neutral.n800 : theme.palette.case.blue.b700,
      },
      '& .MuiAlert-icon': {
        path: {
          fill: theme.palette.case.blue.b600,
        },
      },
    },

    '&.MuiAlert-standardError': {
      border: `1px solid ${theme.palette.case.red.r300}`,
      backgroundColor: theme.palette.case.red.r200,
      '& .MuiAlert-message': {
        color: isLink ? theme.palette.case.neutral.n800 : theme.palette.case.red.r700,
        minWidth: isLink ? '311px' : '100%',
      },
      '& .MuiAlert-icon': {
        path: {
          fill: theme.palette.case.red.r600,
        },
      },
    },

    '&.MuiAlert-standardWarning': {
      border: `1px solid ${theme.palette.case.orange.o300}`,
      backgroundColor: theme.palette.case.orange.o100,
      '& .MuiAlert-message': {
        color: isLink ? theme.palette.case.neutral.n800 : theme.palette.case.orange.o700,
      },
      '& .MuiAlert-icon': {
        path: {
          fill: theme.palette.case.orange.o600,
        },
      },
    },

    '&.MuiAlert-standardSuccess': {
      border: `1px solid ${theme.palette.case.primary.p200}`,
      backgroundColor: theme.palette.case.primary.p100,
      '& .MuiAlert-message': {
        color: isLink ? theme.palette.case.neutral.n800 : theme.palette.case.primary.p900,
      },
    },
  },
}));
